import _axios from '@/assets/utils/_axios'
import {_alert, _loading} from '../../assets/utils/utils'
import Router from '@/router'
import {formatEditor} from '../../assets/utils/GlobalFunction'

//获取列表数据时，page固定从路由中获取,数据默认获取10条
const NUM = 10;
export default {
  /*集团用户获取门店中间页的信息列表*/
  async groupGetStoreLists({commit, getters}, data) {
    let type = data.type == 9 ? 'money' : 'province'
    let res = await _axios.post('/pc/Common/GroupHotelList', {order_by: type,num: 10, ...data})
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data.list || [], total = res.data.count || 0
      commit('UPDATESTORELISTS', {total, lists})
    }
  },
  /*采购商集团用户获取门店中间页的信息列表*/
  async TraGroupGetStoreLists({commit, getters}, {url,data}) {
    let page = Router.currentRoute.query.page || 1;
    let loading = _loading({target: '.load-area'})
    let res = await _axios.post(url, {page, num: 10, ...data})
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data || [], total = res.count || 0
      commit('UPDATESTORELISTS', {total, lists})
    }
  },
  /*获取门店基本信息*/
  async getStoreInfo({commit, getters}, data = {}) {
    //门店ID不存在停止调用
    let t = getters.storeInfo.type;
    let v = getters.storeInfo.verify;
    let url = '',res={info:{},user_data:{},data:{info:{}}};
    switch (getters.storeInfo.type*1) {
      case 2:
        url = '/pc/User/TravelInfo';
        break;
      case 3:
        url = '/pc/User/HotelInfo';
        break;
    }
    if (getters.userInfo.type === 99) {
      switch (getters.storeInfo.type*1) {
        case 2:
          url = '/pc/Admin/TravelDetail';
          break;
        case 3:
          url = '/pc/Admin/HotelDetail';
          break;
        default:
          break;
      }
    }
    // if (getters.isAdmin || getters.isGroup) url = '/pc/Admin/HotelDetail';
    // else url = v > 0 ? '/pc/User/HotelInfo' : '/pc/User/HotelInfo';
    if (t == 4) { url = '/pc/Admin/GuideDetail'; data = {} }
    //未生成门店ID调用登录初始化
     if(getters.storeInfo.storeId==''){ 
        res.code = '00000';
        res.info=getters.info_store_arr;
     }else{
      res = await _axios.post(url, {
        store_id: getters.storeInfo.storeId || Router.currentRoute.query.store,
        is_get_store_user_arr: '1',
        store_type: getters.storeInfo.type,
        ...data
      });
     };
    if (res.code === '00000') {
      let resInfo = {
        ...res.user_data,
        ...res.data.info,
        ...res.info,
        person_liable_id:res.data.info.person_liable_id*1,
        user_arr:res.data.user_arr|| [],
        edit_verify:res.data.edit_verify|| [],
        order_arr:res.data.order_arr|| [],
        bankcard: res.bankcard_total_nums || 0,
        bankcard: res.bankcard_total_nums || 0,
        invoice: res.invoice_total_nums || 0,
        activityInfo: res.data.order_arr || {},
        contractList: res.data.contract_arr || [],
        adminList: res.data.admin_arr || [],
        userArr: res.data.user_arr || [],
        roomArr: res.data.room_arr || [],
        meetArr: res.meeting_arr || [],
        onsaleArr: res.onsale_arr || {},
        ticketArr: res.ticket_arr || {},
        itineraryArr: res.itinerary_arr || {},
        restaurantArr: res.restaurant_arr || {},
        msg: res.order_arr || {},
        user: res.user_arr || {},
        bankcard_arr: res.data.bankcard_arr || [],
  
      }; 
      commit('UPDATESTOREBASIC', resInfo);
      commit('UPDATECURRENTSTORE', {verify: resInfo.verify})
      //保存审核状态值
      let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
      userMessage.verify = res.data.info.verify;
      commit('UPDATELOGININFO', { ...userMessage });
      commit('UPDATECURRENTSTORE', {verify: res.data.info.verify});
      return resInfo.verify;
    }
  },
  /*注册门店信息*/
  async saveStoreInfo({commit, getters}, {type,newInfo,saveImages, successFun,preservation}) {
    let loading = _loading({target: '.load-area'});
    let url ='';
    switch (getters.storeInfo.type) {
      case 2:
        url = preservation!=1?'/pc/User/RegTravelBaseInfo':'/pc/Travel/EditBaseInfo';
        break;
      case 3:
        // url = preservation!=1?'/pc/User/RegHotelBaseInfo':'/pc/Hotel/EditBaseInfo';
        url = preservation!=1?'/pc/User/SellHotelSave':'/pc/Hotel/EditBaseInfo';
        break;
    }
    if (getters.userInfo.type === 99) {
      switch (getters.storeInfo.type) {
        case 2:
          url = '/pc/Admin/EditTravelBase';
          break;
        case 3:
          url = '/pc/Admin/EditHotelBase';
          break;
        case 5:
          url = '/pc/Admin/saveHomestayInfo';
          break;
        case 6:
          url = '/pc/Admin/saveViewpointInfo';
          break;
        case 8:
            url = '/pc/Admin/saveBrandhallData';
            break;
        default:
          break;
      }
    }
      //集团创建门店
      // newInfo.intro = await formatEditor(newInfo.intro);           //上传门店简介中的图片
      let data = {
        store_id: getters.storeInfo.storeId,
        ...newInfo,
      }
      delete data.user_arr;
      delete data.userArr;
      delete data.order_arr;
      delete data.activityInfo;
      delete data.store_tel;
      if (type === 'groupAddStore') {
        url = '/pc/Common/AddGroupHotel';
        delete data.store_id
      }
      let res = await _axios.post(url, data);
      loading.close();
      if (res.code === '00000'){ 
        //酒店销售创建门店未生成门店ID则返回保存的门店ID
          let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
          //销售身份时
          if(userMessage.submit_store_id==0&&getters.storeInfo.level==3){ 
            userMessage.submit_store_id = res.data.info.store_id;
            commit('UPDATELOGININFO', { ...userMessage })
          };
        _alert('信息保存成功', () => successFun(res.info))
      }
    },
  /*保存门店相册*/
  async HotelsEditAlbum({commit, getters},{type, newInfo,saveImages, successFun}) {
    let url = '';
    switch (getters.userInfo.type) {
      case 3:
        url = '/pc/User/EditAlbum';
        break;
      case 99:
        url = '/pc/Admin/EditHotelAlbum';
        break;
    };
    newInfo.intro = await formatEditor(newInfo.intro);
    let data = {
      store_id: getters.storeInfo.storeId,
      ...newInfo,
    };
    let res = await _axios.post(url, data) ;
    if (res.code === '00000') _alert('信息保存成功', () => successFun(res.info));
  },
  /*提交门店认证*/
  async setStoreVerify({commit, getters, dispatch}, {data, successFun,verify}) {
    let url
    switch (getters.storeInfo.type) {
      case 2:
        url = verify!=3?'/pc/User/RegTravelSubmit':'/pc/Travel/EditSubmit'
      break
      case 3:
        url = verify!=3?'/pc/User/SellHotelSubmit':'/pc/Hotel/EditSubmit' 
        break
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      ...data
    })
    if (res.code === '00000') successFun()
  },
  /*门店编辑认证信息*/
  async information({commit, getters, dispatch}, data) {
    let loading = _loading({target: '.blank_space'})
    let url
    switch (getters.storeInfo.type) {
      case 2:
        url = '/pc/Travel/EditVerifyInfo'
      break
      case 3:
        url = '/pc/Hotel/EditVerifyInfo'
        break
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
    })
    loading.close()
    if (res.code === '00000') commit('INFORMATINNTEXT', res.data.info)
  },
  /*获取门店房间列表*/
  async getRoomLists({commit, getters},data) {
    let url
    switch (getters.storeInfo.type) {
      case 2:
        url = '/pc/User/GetHotelRoomTitleList'
      break
      case 3:
        url = '/pc/User/GetHotelRoomTitleList'
        break
      case 5:
        url = '/pc/AuthAndBind/getHomestayRoomList'
        break
      case 8:
        url = '/pc/Brandhall/getRoom'
        break
      default:
        break
    }
    let res = await _axios.post(url, {hotel_id: data?data:getters.storeInfo.storeId})
    if (res.code === '00000' || res.code === '99999') {
      //统一处理将房间的照片pic和特征feature切割成数组
      let meetArr = [],total = res.data.count||0;
      meetArr = res.data.list.map(v => {
        return v
      })
      commit('UPDATEROOMLISTS',{meetArr,total})
    }
  },
  /*酒店门店房间列表*/
  async HotelsRoomList({commit, getters},data) {
    let url
    switch (getters.storeInfo.type) {
      case 2:
        url = '/pc/User/GetHotelRoomTitleList'
        break
      case 3:
        url = '/pc/User/RoomList'
        break
    };
    let res = await _axios.post(url, {store_id:getters.storeInfo.storeId,type:0,...data})
    if (res.code === '00000' || res.code === '99999') {
      //统一处理将房间的照片pic和特征feature切割成数组
      let meetArr = [],total = res.data.count||0,info = res.data.info||0;
      meetArr = res.data.list.map(v => {
        return {
          ...v,
          pic: v.pic.trim().split(',').filter(Boolean) || []
        }
      })
      commit('UPDATEROOMLISTS',{meetArr,total,info})
    }
  },
  /*酒店房态列表*/
  async HotelsRoomCalendarList({commit, getters},{data, successFun}) {
    console.log(getters);
    let res = await _axios.post('/pc/Hotel/RoomCalendarList', data)
    if (res.code === '00000') successFun(res.data);
  },
  /*酒店房态添加/修改酒店*/
  async HotelsAddRoom({commit, getters},{data, successFun}) {
    let res = await _axios.post('/pc/Hotel/AddRoomCalendar', data)
    if (res.code === '00000') {
      successFun();
      _alert('修改成功');
    }
  },
  /*酒店房态获取日历已接团数*/
  async HotelsTeamList({commit, getters},{data, successFun}) {
    let res = await _axios.post('/pc/Hotel/RoomCalendarTeamList', {store_id: getters.storeInfo.storeId,...data})
    if (res.code === '00000') {
      successFun(res.data);
    }
  },
  /*获取房间详情*/
  async getRoomDetail({commit, getters}, {type, id}) {
    let url,
      data = {},
      storeType = type || getters.storeInfo.type;
    switch (storeType) {
      case 3:
        url = '/pc/User/RoomInfo';
        data.room_id = id;
        break
      case 5:
        url = '/pc/AuthAndBind/getHomestayRoomDetails';
        data.homestay_room_id = id;
        break
      default:
        break
    }
    let res = await _axios.post(url, data)
    if (res.code === '00000') {
      res.data.info.pic=res.data.info.pic.trim().split(',').filter(Boolean) || []
      commit('UPDATEROOMMEETDETAIL', res.data.info)

    }else{
      commit('UPDATEROOMMEETDETAIL', "")
    }
  },
  /*添加、编辑门店房间*/
  async saveRoom({commit, getters}, {type, data, successFun}) {
    let url
    switch (getters.storeInfo.type) {
      case 3:
        url = type === 'add' ? '/pc/User/AddRoom' : '/pc/User/EditRoom'
        break
      case 5:
        url = type === 'add' ? '/pc/AuthAndBind/addHomestayRoom' : '/pc/AuthAndBind/saveHomestayRoom'
        break
      case 8:
        url = type === 'add' ? '/pc/Brandhall/addRoom' : '/pc/Brandhall/editRoom'
        break
        default:
        break
    }
    let loading = _loading({target: '.blank_space'});
    data.pic=data.pic.join(',');
    let res = await _axios.post(url, { store_id: getters.storeInfo.storeId,...data})
    loading.close()
    if (res.code === '00000') _alert(type==='add'?'添加成功':'修改成功', successFun)
  },
  /*修改房间、会议室排序*/
  async modifyTheOrder({commit, getters}, {type, data}) {
    console.log(type);
    let url
    switch (type) {
      case '房型':
        url =  '/pc/User/RoomSort'
      break
      case '会议室':
        url =  '/pc/User/MeetingSort'
      break
    }
    let res = await _axios.post(url, {...data, store_id: getters.storeInfo.storeId})
    if (res.code === '00000') _alert('修改成功')
  },
  /*获取门店会议室列表*/
  async getMeetLists({commit, getters},data) {
    let url
    switch (getters.storeInfo.type) {
      case 2:
        url = '/pc/User/GetHotelMeetingTitleList'
        break
      case 3:
        url = '/pc/User/GetHotelMeetingTitleList'
        break
      case 5:
        url = '/pc/AuthAndBind/getHomestayMeetingList'
        break
      case 8:
        url = '/pc/Brandhall/getMeeting'
        break
      default:
        break
    }
    let res = await _axios.post(url, {hotel_id: data?data:getters.storeInfo.storeId})
    if (res.code === '00000' || res.code === '99999') {
      //统一处理将房间的照片pic和特征feature切割成数组
      let meetArr = []
      if (res.datainfo) {
        meetArr = res.info.map(v => {
          return v
        })
      }
      commit('UPDATEMEETLISTS',{meetArr})
    }
  },
  /*酒店门店会议室列表*/
  async HotelsMeetLists({commit, getters},data) {
      let url
      switch (getters.storeInfo.type) {
        case 3:
          url = '/pc/User/MeetingList'
          break
      }
      let res = await _axios.post(url, {store_id:getters.storeInfo.storeId,...data})
      if (res.code === '00000' || res.code === '99999') {
        //统一处理将房间的照片pic和特征feature切割成数组
        let meetArr = [],total = res.data.count||0;
        meetArr = res.data.list.map(v => {
          v.pic = v.pic.trim().split(',').filter(Boolean) || []
          v.layout = Array.isArray(v.layout_arr)?v.layout_arr:[];
          return v
        })
        commit('UPDATEMEETLISTS', {meetArr,total})
      }
  },
  /*获取会议室详情*/
  async getMeetDetail({commit, getters}, {type, id}) {
    let url,
      data = {},
      storeType = type || getters.storeInfo.type;
    switch (storeType) {
      case 3:
        url = '/pc/User/MeetingInfo';
        data.meeting_id = id;
        break
      case 5:
        url = '/pc/AuthAndBind/getHomestayMeetingDetails';
        data.homestay_meeting_id = id;
        break
      default:
        break
    }
    let res = await _axios.post(url, data)
    if (res.code === '00000') {
      res.data.info.pic=res.data.info.pic.trim().split(',').filter(Boolean) || []
      commit('UPDATEROOMMEETDETAIL', res.data.info)
    }
  },
  /*添加、编辑门店会议室*/
  async saveMeet({commit, getters}, {type, data, successFun}) {
    let url
    switch (getters.storeInfo.type) {
      case 3:
        url = type === 'add' ? '/pc/User/AddMeeting' : '/pc/User/EditMeeting'
        break
      case 5:
        url = type === 'add' ? '/pc/AuthAndBind/addHomestayMeeting' : '/pc/AuthAndBind/saveHomestayMeeting'
        break
      case 8:
          url = type === 'add' ? '/pc/Brandhall/addMeeting' : '/pc/Brandhall/editMeeting'
          break
      default:
        break
    }
    let loading = _loading({target: '.blank_space'});
    data.pic=data.pic.join(',');
    let res = await _axios.post(url, { store_id: getters.storeInfo.storeId,...data})
    loading.close()
    if (res.code === '00000') _alert('信息保存成功', successFun)
  },
  /*删除酒店、民宿房间、会议室*/
  async deleteRoomMeet({commit, getters}, {type, data, successFun}) {
    let url
    switch (getters.storeInfo.type) {
      case 3:
        url = type === '房型' ? '/pc/User/DelRoom' : '/pc/User/DelMeeting'
        break
      case 5:
        url = type === '房型' ? '/pc/AuthAndBind/delHomestayRoom' : '/pc/AuthAndBind/delHomestayMeeting'
        break
      case 8:
          url = type === '房型' ? 'pc/Brandhall/delRoom' : '/pc/Brandhall/delMeeting'
          break
      default:
        break
    }
    let res = await _axios.post(url, {...data, store_id: getters.storeInfo.storeId})
    if (res.code === '00000') successFun()
  },
  /*采购商获取设置的分享待收款详情*/
  async deleteShare({commit, getters}, {data}) {
    let res = await _axios.post('/pc/Travel/BrokerOrderHotelDetail', {...data, store_id: getters.storeInfo.storeId})
    if (res.code === '00000') {
      return res.data
    }
  },
  /*采购商分享待收款通知*/
  async deleteNotice({commit, getters}, {data, successFun}) {
    let res = await _axios.post('/pc/Travel/BrokerSMS', {...data, store_id: getters.storeInfo.storeId})
    if (res.code === '00000') successFun()
  },
  /*采购商获取小程序支付二维码*/
  async weChatQrCode({commit, getters}, {data, successFun}) {
    let res = await _axios.post('/pc/WechatApplet/GetOrderDetailQRCode', {...data, store_id: getters.storeInfo.storeId,flag:'b'})
    if (res.code === '00000') return res.data
  },
  /*获取门店资金总数信息*/
  async getStoreMoneyInfo({commit, getters}) {
    let loading = _loading({target: '.blank-head'})
    let t = getters.userInfo.type;
    let url = t === 2 ? '/pc/Travel/getCapitalDetails' : '/pc/Common/getCapitalCount'
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      status: 1,
    })
    loading.close()
    if (res.code === '00000') {
      for (let v in res.info) {
        res.info[v] = (res.info[v] / 100).toFixed(2)
      }
      commit('UPDATEMONEYINFO', res.info)
    }
  },
  /*获取门店资金列表、已提现、可提现、冻结金额列表*/
  async getStoreMoneyLists({commit, getters}, {flag, data, successFun}) {
    let loading = _loading({target: '.blank_space'})
    let url, t = getters.userInfo.type, datas = {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      num: 10,
      ...data
    };
    switch (flag) {
      case 'all':
        url = t === 2 ? '/pc/Travel/myFund' : '/pc/Common/getExpList'
        break
      case 'rebate':
        url = '/pc/Travel/getTravelRebate';
        delete datas.store_id;
        datas.id = getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId;
        break
      case 'allowWithdraw':
        url = t === 2 ? '/pc/Travel/getOrderWithdraw' : '/pc/Common/getPutForwardList';
        break
      default:
        url = '/pc/Common/getStoreFrozenFunds'
        break
    }
    let res = await _axios.post(url, datas)
    loading.close()
    if (res.code === '00000' || res.code === '99999') {
      if (successFun) successFun(res);
      let lists = res.info || res.data || [],
        total = res.total_nums || res.allCount || res.num || 0,
        pay = res.pay || 0;
      let money = res.total_money || 0;
      if (lists[0] && lists[0].price) {
        lists.forEach(v => v.finalPrice = Number(v.price.replace(',', '')) - Number(v.deposit.replace(',', '')))
        lists.forEach(v => v.finalPay = Number(v.price_pay.replace(',', '')) - Number(v.deposit_pay.replace(',', '')))
      }
      if (lists.length > 0) {
        lists = lists.map(v => {
          return {...v, checked: false}
        })
      }
      commit('UPDATEMONEYLISTS', {total, lists, money, pay});
      // 管理员需要调酒店接口查询入住日期时加上的
      commit('UPDATEADMINDATALIST', { total, lists, money });
    }
  },
  /*门店申请提现*/
  async storeWithdraw({commit, getters, dispatch}, {data, successFun}) {
    let t = getters.storeInfo.type;
    let url = t === 2 ? '/pc/Travel/travelWithdraw' : '/pc/Common/frozenFunds';
    let res = await _axios.post(url, {
      store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      ...data
    })
    if (res.code === '00000') {
      dispatch('getUserHead');
      successFun();
    }
  },
  /*门店申请开票*/
  async storeApplyInvoice({commit, getters}, {data, successFun}) {
    let res = await _axios.post('/pc/Common/applicationInvoice', {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      ...data
    })
    if (res.code === '00000') successFun();
  },
  /*获取门店客房日历*/
  async getStoreCalendar({commit, getters}, data) {
    let type = ''
    if (getters.brand) type = Router.currentRoute.path.includes('route') ? '2' : '3'
    else type = '1'
    let res = await _axios.post('/pc/Common/roomCalendar', {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      type,
      ...data
    })
    if (res.code === '00000') commit('UPDATECALENDAR', res.info || [])
  },
  /*修改客房日历某一天数据*/
  async setStoreCalendar({commit, getters}, {data, successFun}) {
    let type = ''
    if (getters.brand) type = Router.currentRoute.path.includes('route') ? '2' : '3'
    else type = '1'
    let res = await _axios.post('/pc/Common/setRoomCalendar', {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      type,
      ...data
    })
    if (res.code === '00000') successFun()
  },
  /*获取门店发票列表*/
  async getStoreInvoiceLists({commit, getters}, data = {}) {
    let res = await _axios.post('/pc/Common/getInvoiceList', {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      page: 1,
      num: 10,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [], total = res.total_nums || 0
      commit('UPDATEINVOICELISTS', {total, lists})
    }
  },
  /*删除门店发票信息*/
  async deleteStoreInvoice({dispatch, getters}, id) {
    let res = await _axios.post('/pc/Common/removeInvoice', {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      invoice_id: id,
      is_display: '0'
    })
    if (res.code === '00000') {
      _alert('删除成功', () => {
        dispatch('getStoreInvoiceLists')
      })
    }
  },
  /*添加编辑门店发票信息*/
  async addStoreInvoice({dispatch, getters}, {data, edit}) {
    let loading = _loading({target:'.blank_space'})
    let url
    let msg
    if (edit == 0) {
      url = '/pc/Common/addInvoice'; msg = '添加成功' 
    } else { url = '/pc/Common/editInvoice'; data.invoice_id = data.id; msg = '编辑成功' }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      ...data
    })
    loading.close()
    if (res.code === '00000') {
      _alert(msg, () => {
        Router.back()
      })
    }
  },
  /*获取门店银行卡列表*/
  async getStoreBankcardLists({commit, getters}, data = {}) {
    let url='',type={};
    switch (getters.storeInfo.type) {
      case 3:
      case 2:
        url = '/pc/User/BankCardList';
        type = {
          store_id: getters.storeInfo.storeId,
          store_type: getters.storeInfo.type,
        }
        break;
      case 99:
        url = '/pc/Admin/BankCardVerifyList';
        break;
    }
    let res = await _axios.post(url, {
      ...type,
      page: 1,
      num: 10,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data.list || [], total = res.data.count|| 0
      commit('UPDATEBANKCARDLISTS', {total, lists})
    }
  },
  /*获取门店银行卡详情*/
  async getStoreBankcardDetails({commit, getters}, {id, successFun}) {
    let url='',type={};
    switch (getters.storeInfo.type) {
      case 3:
        url = '/pc/User/BankCardInfo';
        type = {
          store_id: getters.storeInfo.storeId,
        }
        break;
      case 99:
        url = '/pc/Admin/BankCardInfo';
        break;
    }
    let res = await _axios.post(url, {
      ...type,
      id:id
    })
    if (res.code === '00000') {
      successFun(res.data.info)
    }
  },
  /*添加门店银行卡*/
  async addStoreBankcard({commit, getters}, {data,modes}) {
    let url = modes==0?'/pc/User/AddBankCard':'/pc/User/EditBankCard'  //添加-编辑修改
    let loading = _loading({target: '.load-area'})
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      ...data
    })
    loading.close()
    if (res.code === '00000') {
      _alert(modes==0?'添加成功':'修改成功', () => {
        Router.back()
      })
    }
  },
   /*审核门店银行卡*/
   async reviewBankcard({dispatch, getters}, data = {}) {
    let loading = _loading({target: '.load-area'})
    let res = await _axios.post('/pc/Admin/BankCardVerify', {
      ...data
    })
    loading.close()
    if (res.code === '00000'){
      _alert('操作成功', () => {
        dispatch('getUserIndexData')
        Router.back()
      })
    }
  },
    /*修改银行卡备注*/
    async getStoreBankcardNotes({dispatch, getters}, data = {}) {
      let res = await _axios.post('/pc/User/RemarkBankCard', {
        store_id: getters.storeInfo.storeId,
        ...data
      })
      if (res.code === '00000') _alert('修改成功', () => dispatch('getStoreBankcardLists'))
    },
  /*设置银行卡为默认（编辑银行卡接口，银行卡除了设置默认，其他不可编辑）*/
  async setStoreBankcard({dispatch, getters}, data = {}) {
    let res = await _axios.post('/pc/User/DefaultBankCard', {
      store_id: getters.storeInfo.storeId,
      ...data
    })
    if (res.code === '00000') _alert('设置成功', () => dispatch('getStoreBankcardLists'))
  },
  /*删除门店银行卡*/
  async deleteStoreBankcard({dispatch, getters}, data = {}) {
    let res = await _axios.post('/pc/User/DelBankCard', {
      store_id: getters.storeInfo.storeId,
      ...data
    })
    if (res.code === '00000') _alert('删除成功', () => dispatch('getStoreBankcardLists'))
  },
  /*获取酒店促销、民宿活动列表*/
  async getStoreDiscountLists({commit, getters}, data = {}, status) {
    let loading = _loading({target: '.load-area'});
    let t = getters.storeInfo.type, url = '';
    switch (t) {
      case 3:
        url = '/pc/Hotel/getOnsale';
        break;
      case 5:
        url = '/pc/Homestay/getHomestayOnsaleList';
        break;
      case 8:
        url = 'pc/Brandhall/getItinerary'
        data.store_type = 8;
        if (status) data.status = status
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      page: 1,
      num: 10,
      ...data
    })
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [], total = res.total_nums || 0
      commit('UPDATEDISCOUNTLISTS', {total, lists})
    }
  },
  /*删除促销活动*/
  async deleteStoreDiscount({dispatch, getters}, id) {
    let url = '/pc/Hotel/delOnsale', t = getters.storeInfo.type
    let data = { store_id: getters.storeInfo.storeId, onsale_id: id }
    if (t == 5) {
      url = '/pc/Homestay/delHomestayOnsale';
      delete data.onsale_id;
      data.homestay_onsale_id = id
    }
    if (t == 8) {
      url = '/pc/Brandhall/delItinerary'
      delete data.onsale_id;
      data.itinerary_id = id;
      data.store_type = t
    }
    let res = await _axios.post(url, data)
    if (res.code === '00000') _alert('删除成功！', () => dispatch('getStoreDiscountLists'))
  },
  /*获取酒店促销、民宿活动详情*/
  async getDiscountDetail({commit, getters}, id,status) {
    let t = getters.storeInfo.type, url = '', data = {}, storeId = getters.storeInfo.storeId,
      n = Router.currentRoute.name === 'addEditActivity'; //真-民宿活动，假-酒店促销
    switch (t) {
      case 3:
        url = '/pc/Hotel/getHotelActive';
        data = {hotelId: storeId, id}
        break;
      case 5:
        url = '/pc/Homestay/getHomestayOnsaleDetails';
        data = {store_id: storeId, homestay_onsale_id: id}
        break;
      case 8:
        url = 'pc/Brandhall/getItinerary'
        data = {store_id: storeId,store_type:8,itinerary_id:id,status,order_by:'sort desc'}
        break;
      case 99:
        url = n ? '/pc/Admin/getHomestayOnsaleDetails' : '/pc/Admin/adminShowHotelActiveMess';
        data = n ? {homestay_onsale_id: id} : {storeId: getters.storeInfo.storeId, id}
        break;
    }
    let res = await _axios.post(url, data)
    if (res.code === '00000') commit('UPDATEDISCOUNTDETAIL', res.info)
  },
  /*添加、编辑促销活动*/
  async addEditDiscount({dispatch, getters}, {type, data, successFun}) {
    let t = getters.storeInfo.type, url = ''
    if (type == 'add') {
      url = t == 3 ? '/pc/Hotel/addOnsale' : t == 8 ? 'pc/Brandhall/addItinerary' : '/pc/Homestay/addHomestayOnsale'
    } else {
      url = t == 3 ? '/pc/Hotel/saveOnsale' : t == 8 ? 'pc/Brandhall/editItinerary' : '/pc/Homestay/saveHomestayOnsale'
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      ...data,
    })
    if (res.code === '00000') _alert('操作成功！', () => {
      if (successFun) successFun();
      else Router.back();
    })
  },
  /*品牌馆添加用餐*/
  async addEditEatery({dispatch, getters}, {type, data, successFun}) {
    let url = ''
    if (type === 'add') url = 'pc/Brandhall/addRestaurant'
    else url = 'pc/Brandhall/editRestaurant'
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      store_type: 8,
      ...data,
    })
    if (res.code === '00000') _alert('操作成功！', () => {
      if (successFun) successFun();
      else Router.back();
    })
  },
  /*添加编辑民宿或品牌馆活动的具体类型*/
  async addEditActiType({dispatch, getters}, {type, data}) {
    let url
    switch (getters.storeInfo.type) {
      case 5:
        url = type == 'add' ? '/pc/Homestay/addHomestayOnsaleDetails' : '/pc/Homestay/saveHomestayOnsaleDetails';
        break
      case 8:
        url = type == 'add' ? 'pc/Brandhall/addItineraryDetails' : 'pc/Brandhall/editItineraryDetails'
        break
      default:
        break
    }
    let actiId = Router.currentRoute.query.discount;
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      ...data,
    })
    if (res.code === '00000') _alert('操作成功！', () => {
      dispatch('getDiscountDetail', actiId)
      if (getters.storeInfo.type == 8) Router.back()
    })
  },
  /*删除民宿、品牌馆活动的具体类型*/
  async deleteActiType({dispatch, getters}, id) {
    let actiId = Router.currentRoute.query.discount;
    let url;
    let data = { store_id: getters.storeInfo.storeId }
    if (getters.brand) {
      url = 'pc/Brandhall/delItineraryDetails';
      data.store_type = 8;data.itinerary_id = actiId;
      data.itinerary_details_id = id
    } else { url = '/pc/Homestay/delHomestayOnsaleDetails'; data.homestay_onsale_details_id = id }
    let res = await _axios.post(url, data)
    if (res.code === '00000') _alert('删除成功！', () => dispatch('getDiscountDetail', actiId))
  },
  /*获取景区门票,品牌馆活动列表*/
  async getStoreTicketLists({commit, getters}, data = {}) {
    let loading = _loading({target: '.load-area'});
    let url = '/pc/Viewpoint/getTicketList'
    if (getters.userInfo.type == 8) { url = '/pc/Brandhall/getOnsale'; data.order_by = 'sort desc' }
    let res = await _axios.post(url, {
      store_id: getters.isGroup ? Router.currentRoute.query.id : getters.storeInfo.storeId,
      page: 1,
      num: 10,
      ...data
    })
    loading.close();
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [], total = res.total_nums || 0;
      commit('UPDATETICKETLISTS', {total, lists});
    }
  },
  // 获取餐饮列表
  async getStoreEateryLists({commit, getters}, {data, successFun}) {
    let res = await _axios.post('pc/Brandhall/getRestaurant', {
      store_id: getters.isGroup ? Router.currentRoute.query.id : getters.storeInfo.storeId,
      store_type: 8,
      order_by: 'sort desc',
      page: 1,
      num: 10,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [], total = res.total_nums || 0;
      commit('UPDATEATERYELISTS', {total, lists});
      if (successFun) successFun(res);
    }
  },
  /*景区、管理员添加编辑景区门票*/
  async addEditTicket({dispatch, getters}, data) {
    let loading = _loading({target: '.load-area'});
    let url = '';
    if (getters.isAdmin) url = '/pc/Admin/verifyTicket';
    else {
      switch (getters.userInfo.type) {
        case 6:
          url = data.ticket_id ? url = '/pc/Viewpoint/editTicket' : url = '/pc/Viewpoint/addTicket';
          break;
        case 8:
          url = data.onsale_id ? url = '/pc/Brandhall/editOnsale' : url = '/pc/Brandhall/addOnsale';
          break;
      }
    }
    let res = await _axios.post(url, {
      store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
      ...data
    })
    loading.close();
    if (res.code === '00000') _alert('操作成功！', () => {
      if (!Router.currentRoute.path.includes('manage')) Router.back();
      else dispatch('getStoreTicketLists')
      dispatch('getWaitHandleData');
    })
  },
  /*获取门票详情*/
  async getTicketDetail({commit, getters}, ticketId) {
    let url = '', data = {
      ticket_id: ticketId
    };
    if (getters.isAdmin) url = '/pc/Admin/getTicketDetails';
    else {
      url = '/pc/Viewpoint/getTicketDetails';
      if (getters.userInfo.type == 8) {
        url = 'pc/Brandhall/getOnsale'
        data.onsale_id = ticketId;
        delete data.ticket_id
      }
      data.store_id = getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId;
    }
    let res = await _axios.post(url, data)
    if (res.code === '00000') {
      commit('UPDATETICKETDETAIL', res.info);
    }
  },
  /*删除门票*/
  async deleteStoreTicket({commit, getters, dispatch}, ticketId) {
    let url = '/pc/Viewpoint/delTicket'
    let data = {
      store_id: getters.isGroup ? Router.currentRoute.query.id : getters.storeInfo.storeId,
      ticket_id: ticketId
    }
    if (getters.userInfo.type == 8) {
      url = 'pc/Brandhall/delOnsale'
      data.onsale_id = ticketId; delete data.ticket_id
    }
    let res = await _axios.post(url, data)
    if (res.code === '00000') _alert('删除成功！', () => dispatch('getStoreTicketLists'))
  },
  /*删除用餐*/
  async deleteStoreEatery({commit, getters, dispatch}, eatId) {
    let res = await _axios.post('pc/Brandhall/delRestaurant', {
      store_id: getters.isGroup ? Router.currentRoute.query.id : getters.storeInfo.storeId,
      store_type: 8,
      restaurant_id: eatId
    })
    if (res.code == ('00000' || '99999')) _alert('删除成功！', () => dispatch('getStoreEateryLists'))
  },
  /*门店获取统计报表数据*/
  async getStoreChartLists({commit, getters, dispatch}, data) {
    let loading = _loading({target: '.load-area'});
    let url = '';
    switch (getters.storeInfo.type) {
      case 2:
        url = '/pc/Travel/show_numerical_statement';
        break;
      case 3:
        url = '/pc/Hotel/hotelReportForm';
        break;
      case 5:
        url = '/pc/Homestay/getReportForm';
        break;
      case 6:
        url = '/pc/Viewpoint/getReportForm';
        break;
      case 8:
        url = '/pc/Brandhall/getReportForm';
        break
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      store_type: getters.storeInfo.type,
      ...data
    })
    loading.close();
    if (res.code === '00000' || res.code == '99999') {
      let resInfo = [];
      if (data.is_merge) resInfo.push(res.info);//根据时间查看，返回的是对象(非采购商身份时)
      else resInfo = res.info || [];            //默认拉取，返回的是数组
      resInfo.forEach(v => {
        for (let key in v) {
          if (key === 'success_order_nos' || key == 'order_nos') v.total_order_nos = v[key];
          if (key === 'success_order_pay') v.total_pay_price = v[key];
          if (key === 'success_order_price') v.total_price = v[key];
          if (!v[key]) v[key] = 0;
        }
      })
      if (getters.storeInfo.type === 2) {
        resInfo = res.data || []
      }
      commit('UPDATECHARTLIST', resInfo);
    }
  },
  /*门店获取报表详情数据*/
  async getStoreChartDetail({commit, getters, dispatch}, data) {
    let url = '', PAGE = Router.currentRoute.query.page || 1;
    let storeType = getters.storeInfo.type
    switch (storeType) {
      case 3:
        url = '/pc/Hotel/hotelReportFormDetails';
        break;
      case 5:
        url = '/pc/Homestay/getReportFormDetails';
        break;
      case 6:
        url = '/pc/Viewpoint/getReportFormDetails';
        break;
      case 8:
        url = '/pc/Brandhall/getOrderList';
        break;
    }
    let res = await _axios.post(url, {
      store_type: getters.storeInfo.type,
      num: NUM,
      page: PAGE,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [], total = res.total_nums || 0;
      lists.forEach(v => {
        for (let key in v) {
          if (key == 'time') v.order_send_time = v[key];
          if (key == 'price_pay') v.money = v[key];
          if (key == 'oid' && storeType != 3) v.order_nos = v[key];
          //if (!v[key]) v[key] = 0;
        }
      })
      commit('UPDATECHARTDETAIL', {total, lists});
    }
  },
  /*获取评论列表数据*/
  async getCommentLists({commit, getters, dispatch}, data) {
    let loading = _loading({ target: '.load-area' });
    let url = '', PAGE = Router.currentRoute.query.page || 1;
    switch (getters.storeInfo.type) {
      case 2:
        url = '/pc/Travel/getOrderCommentList';
        break;
      case 4:
        url = '/pc/Guide/getOrderCommentList';
        break;
      case 99:
        url = '/pc/Admin/getCommentList';
        break;
      default:
        url = '/pc/Common/getCommentList';
        break;
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      num: NUM,
      page: PAGE,
      ...data
    })
    loading.close()
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [], total = res.total_nums || 0;
      commit('UPDATECOMMENTLISTS', {total, lists});
    }
  },
  /*获取评论详情*/
  async getCommentDetail({commit, getters, dispatch}, id) {
    let url = '', data = {
      oid: id
    }, t = getters.storeInfo.type;
    switch (t) {
      case 2:
        url = '/pc/Travel/getComment';
        break;
      case 4:
        url = '/pc/Guide/getComment';
        break;
      case 99:
        url = '/pc/Admin/getCommentData';
        data.comment_id = id;
        delete data.oid;
        break;
      default:
        url = '/pc/Common/getCommentData';
        data.comment_id = id;
        delete data.oid;
        break;
    }
    let res = await _axios.post(url, data);
    if (res.code === '00000') {
      let resInfo = t === 2 ? res.info : [res.info]
      commit('UPDATECOMMENTDETAIL', resInfo);
    }
  },
  /*采购商发布评论时获取的订单详情*/
  async getPostCommentDetail({commit, getters}, data) {
    let url = '';
    switch (Number(data.orderType)) {
      case 3:
        url = '/pc/Travel/getHotelOfferMess';
        break;
      case 5:
        url = '/pc/Travel/homestayOrderComment';
        break;
      case 6:
        url = '/pc/Travel/viewpointOrderComment';
        break;
      case 8:
        url = '/pc/Travel/getBrandhallOrderDetails'
        break;
    }
    let datas = { store_id: getters.storeInfo.storeId,id: data.orderId }
    if (data.orderType == 8) { datas.oid = data.orderId; delete datas.id }
    let res = await _axios.post(url, datas);
    if (res.code === '00000') commit('UPDATECOMMENTDETAIL', res);
  },
  /*发布评论*/
  async commentPost({commit, getters}, data) {
    let res = await _axios.post('/pc/Travel/travelComment', {
      comment_store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
      comment_store_type: getters.storeInfo.type,
      ...data
    });
    if (res.code === '00000') _alert('评论发布成功', () => Router.back());
  },
  /*管理员审核评论*/
  async adminVerifyComment({commit, getters, dispatch}, data) {
    let res = await _axios.post('/pc/Admin/verifyComment', data);
    if (res.code === '00000') _alert('审核成功', () => {
      Router.back();
      dispatch('getWaitHandleData');
    });
  },
  /*门店回复评论*/
  async storeReplyComment({commit, getters}, data) {
    let res = await _axios.post('/pc/Common/replyComment', data);
    if (res.code === '00000') _alert('回复成功', () => Router.back());
  },
  /*获取门店收藏列表*/
  async getCollectList({commit, getters}, data) {
    let res = await _axios.post('/pc/Travel/fav_hotel', {
      store_id: getters.storeInfo.storeId,
      page: Router.currentRoute.query.page || 1,
      num: NUM,
      ...data
    });
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data || [],
        total = res.favCount || 0;
      commit('UPDATECOLLECTLISTS', {total, lists});
      return res;
    }
  },
  /*取消收藏*/
  async cancelCollect({dispatch, getters}, {id, successFun}) {
    let res = await _axios.post('/pc/Travel/del_fav_hotel', {
      store_id: getters.storeInfo.storeId,
      id
    });
    if (res.code === '00000') successFun()
  },
  /*获取门店积分、活跃明细*/
  async getStoreCredit({commit, getters},{ storeId }) {
    let url = '', data = {
      store_id: storeId,
      page: Router.currentRoute.query.page || 1,
      num: NUM,
    };
    switch (getters.storeInfo.type) {
      case 2:
        url = '/pc/Travel/ExpList';
        break;
      default:
        url = '/pc/Hotel/ExpList';
        data = {
          ...data,
          store_type: getters.storeInfo.type,
        }
        break;
    }
    let res = await _axios.post(url, data);
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data.list  || [],
        total = res.data.count || res.num || 0;
      commit('UPDATECREDITLIST', {total, lists});
      return res;
    }
  },
  /*获取门店提现详情*/
  async getWithdrawDetail({commit, getters}, data) {
    let res = await _axios.post('pc/Common/getPutForwardDetails', data);
    if (res.code === '00000') {
      let info = res.info || {};
      info.arr = res.withdraw_arr || []
      commit('UPDATEWITHDRAWDETAIL', info);
    }
  },
  /*获取旅游产品返利*/
  async getRebateIncome({commit, getters}, {data, successFun}) {
    let res = await _axios.post('/pc/Common/getProductRebate',{
      store_id: getters.isGroup ? Router.currentRoute.query.storeId : getters.storeInfo.storeId,
      num: 10,
      ...data
    });
    if (res.code === '00000' || res.code === '99999') {
       if (res.data) {
        if (data.hasOwnProperty('num')) res.data.forEach(v => v.checked = true);
        else res.data.forEach(v => v.checked = false)
      }
      commit('UPDATEREBATEINFO',res);
      successFun()
    }
  }
}
